import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductDelivery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateDelivery);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateDelivery);
  }

  /**
   * Updates the delviery.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateDelivery = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDeliveryStatus = event.detail.data.html.querySelector('product-delivery');

    if (!newDeliveryStatus) return;

    if (newDeliveryStatus.hasAttribute('hidden')) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }

    morph(this, newDeliveryStatus, { childrenOnly: true });
  };
}

if (!customElements.get('product-delivery')) {
  customElements.define('product-delivery', ProductDelivery);
}
